import { Component, NgModule, OnInit } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Gebaeude } from 'src/app/data/ws/dbKlassen/gebaeude.model';
import { MatTableDataSource } from '@angular/material/table';
import { Lightbox, LightboxModule } from 'ngx-lightbox';
import { Functions } from 'src/app/functions/functions.module';
import { FormControl } from '@angular/forms';
import { ConstantsTableColsUebersichtGebaeude } from 'src/app/immutable/cols/constants-table-cols-uebersicht-gebaeude';
import { AuswahlComponent } from '../../pages/anwendung/auswahl/auswahl.component';
import { GlobalConstantsSonstige } from 'globales-projekt-angular';


@Component({
  selector: 'app-uebersicht-tabelle',
  templateUrl: './uebersicht-tabelle.component.html',
  styleUrls: ['./uebersicht-tabelle.component.css']
})

export class UebersichtTabelleComponent implements OnInit {
  @NgModule({
    imports: [LightboxModule]
  })

  position = new FormControl(GlobalConstantsSonstige.POSITION_OPTIONS[0]);

  isAdd!: boolean;
  gebaeude!: Gebaeude[]; // TODO Umbenennen in gebaeudeList
  parentMainComponent!: AuswahlComponent;
  id!: Guid;
  dataSource!: MatTableDataSource<Gebaeude>;
  displayedCols!: string[];
  //  displayedColssHeader!: string[];
  added: Map<number, boolean> = new Map<number, boolean>();


  constructor(private lightbox: Lightbox) { }

  ngOnInit(): void {
  }

  setVariablen(gebaeude: Gebaeude[], isAdd: boolean, selectedGebaeudeIds: number[]) {
    this.gebaeude = gebaeude;
    this.isAdd = isAdd;

    this.displayedCols =
      ConstantsTableColsUebersichtGebaeude.getColumns(isAdd);

    this.dataSource = new MatTableDataSource(gebaeude);

    if (isAdd) {
      this.gebaeude.forEach(geb => { 
        this.added.set(geb.idGebaeude, selectedGebaeudeIds && selectedGebaeudeIds.includes(geb.idGebaeude));
      });
    }
  }

  addEntry(gebaeude: Gebaeude) {

    this.added.set(gebaeude.idGebaeude, true);
    this.parentMainComponent.addSelectedEntry(gebaeude);
  }

  removeEntry(gebaeude: Gebaeude) {

    this.parentMainComponent.removeSelectedEntry(gebaeude);
  }

  openGallery(gebaeude: Gebaeude): void {
    Functions.openGallery(this.lightbox, gebaeude);
  }

  getAddedStatus(id: number): boolean {
    return this.added.get(id) ?? false;
  }

  toggleEntry(entry: Gebaeude, checked: boolean): void {
    if (checked) {
      this.addEntry(entry);
    } else {
      this.removeEntry(entry);
    }
  }  
}

